import React from 'react';
import { styled } from 'styled-components';
import { COLORS, computeRemSize } from '@ydistri/theme';
import { Popover } from 'antd';
import { AiOutlineEyeInvisible } from 'react-icons/ai';
import { ICON_SIZE_COMPACT, ICON_SIZE_NORMAL } from './calculationRowLib';

const PrivateCalculationIndicatorWrapper = styled.div`
  margin-left: auto;
  color: ${() => COLORS.PRIMARY};
`;

interface PrivateCalculationIndicatorProps {
  compact?: boolean;
}

const PrivateCalculationIndicator: React.FC<PrivateCalculationIndicatorProps> = ({ compact }) => {
  return (
    <Popover content="Private calculation">
      <PrivateCalculationIndicatorWrapper data-type="indicator-calculation-private">
        <AiOutlineEyeInvisible
          size={computeRemSize(compact ? ICON_SIZE_COMPACT : ICON_SIZE_NORMAL)}
        />
      </PrivateCalculationIndicatorWrapper>
    </Popover>
  );
};

export default PrivateCalculationIndicator;
